import React from 'react';
import useFilters from 'state/filters';

export const withFiltersContext = (Component) => (props) => {
    const [filters] = useFilters();

    return <Component {...props} items={filters.items.list} />;
};
